import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  collapsedSidebar: false,
  openSidebarDrawer: false,
};

const dashboardSlice = createSlice({
  name: 'dashboard_store',
  initialState,
  reducers: {
    setCollapsedSidebar(state, action: { payload: boolean }) {
      state.collapsedSidebar = action.payload;
    },
    setOpenSidebarDrawer(state, action: { payload: boolean }) {
      state.openSidebarDrawer = action.payload;
    },
  },
});

const { actions, reducer } = dashboardSlice;

export const { setOpenSidebarDrawer, setCollapsedSidebar } = actions;
export { reducer };
